import * as React from "react";
const TickerCoupons = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={37} height={36} fill="none">
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeWidth={2.25}
        d="M7.33 20.054a3 3 0 0 1-.833-2.642l1.485-8.415a3 3 0 0 1 2.433-2.433l8.415-1.485a3 3 0 0 1 2.643.833l12.33 12.33a3 3 0 0 1 0 4.243l-9.9 9.9a3 3 0 0 1-4.242 0L7.33 20.055Z"
      />
      <circle
        cx={13.297}
        cy={11.879}
        r={2}
        stroke="currentColor"
        strokeWidth={2.25}
        transform="rotate(-45 13.297 11.879)"
      />
      <path
        fill="currentColor"
        d="m18.33 18.405-1.89-1.89 1.653-1.654 1.89 1.891-1.653 1.653Zm7.049.376c.402.403.65.868.742 1.396.093.515.037 1.053-.168 1.614-.205.548-.558 1.072-1.06 1.574-.62.62-1.27 1.04-1.95 1.257-.68.205-1.395.182-2.148-.07l.465-2.227c.555.093.99.06 1.307-.099.324-.165.59-.353.802-.564.145-.145.254-.293.327-.445.079-.159.066-.29-.04-.396-.086-.086-.204-.126-.356-.12-.145 0-.35.06-.614.18-.257.111-.597.306-1.02.583-.514.317-.996.521-1.445.614-.442.086-.864.06-1.267-.08-.403-.151-.785-.409-1.148-.771a2.794 2.794 0 0 1-.773-1.367c-.118-.527-.082-1.072.11-1.633.19-.574.55-1.125 1.078-1.653.588-.588 1.205-.967 1.852-1.139.653-.178 1.263-.2 1.831-.069l-.366 2.307a1.6 1.6 0 0 0-.96.168c-.324.152-.598.34-.822.564a1.245 1.245 0 0 0-.327.505c-.053.172-.023.314.09.426a.39.39 0 0 0 .257.119c.105 0 .247-.043.425-.13.172-.091.403-.23.693-.415.984-.614 1.828-.937 2.535-.97.7-.04 1.35.24 1.95.841Zm-.159 6.514-1.811-1.811 1.653-1.654 1.811 1.812-1.653 1.653Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M.6 0h36v36H.6z" />
      </clipPath>
    </defs>
  </svg>
);
export default TickerCoupons;
